export enum PercentageDataType {
  Default = 1,
  Specific = 2,
  Year = 3,
  Km = 4,
  Tramer = 5,
  City = 8
}
